<template>
<v-dialog
  :value="showDlgDelete"
  persistent
  @close="$emit('closeModal')"
  max-width="500"
  :content-class="'ModalDeleteBanner'"
>
  <v-card class="ModalDeleteBanner__card d-flex flex-column px-6 py-4">
    <div class="ModalDeleteBanner__close d-flex justify-end">
      <v-btn
        small
        @click="$emit('closeModal')">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div class="ModalDeleteBanner__title">
      Удаление баннера
    </div>

    <div class="ModalDeleteBanner__body">
      Вы уверены, что хотите удалить баннер?<br>
      Действие не может быть отменено.
    </div>
    <div class="ModalDeleteBanner__btn-group">
      <div>
        <v-btn
          class="mr-3 _w-100"
          outlined
          color="primary"
          @click="cancel"
        >
          Отменить
        </v-btn>
      </div>
      <div>
        <v-btn
          class="_w-100"
          color="primary"
          @click="acceptDelete"
        >
          Удалить
        </v-btn>
      </div>

    </div>
  </v-card>
</v-dialog>
</template>

<script>

/**
 * Компонент: ModalDeleteBanner
 * Описание:
 */
export default {
  name: 'ModalDeleteBanner',

  components: { },

  props: {
    showDlgDelete: {
      type: Boolean,
      default: false
    }
  },
  emits: ['closeModal', 'acceptDelete'],

  data() {
    return {};
  },

  computed: {},

  watch: {},

  created() {
  },

  mounted() {
  },

  beforeDestroy() {
  },

  methods: {
    acceptDelete() {
      this.$emit('acceptDelete');
    },
    cancel() {
      this.$emit('closeModal');
    }
  },
};
</script>

<style scoped lang="scss">
 .ModalDeleteBanner{
  &__card{
    border-radius: 20px !important;
    box-shadow: none !important;
    gap: 24px;
  }

  &__close{
    & > button{
      box-shadow: none !important;
      background: transparent;
    }
  }

  &__title {
    font-size: 22px;
    color: var(--color-blue-500);
    font-weight: 600;
    text-align: center;
  }

  &__btn-group{
    display: flex;
    justify-content: center;
  }

  &__body{
    text-align: center;
  }

}
</style>
